/**
 * EU-762 (QA 01/10) — liga o store de offline ANTES de o router existir.
 *
 * O gate fecha a própria entrada de histórico com `history.back()` e engole o
 * `popstate` resultante (`stopImmediatePropagation`) para ele não chegar ao
 * TanStack Router — que trataria o evento como navegação e acionaria o
 * `useBlocker` da tela ("Quer sair sem terminar?" / "Tem certeza?").
 *
 * O desenho original apostava na fase de CAPTURA para correr na frente. Só que
 * os dois listeners estão no MESMO alvo (`window`), e no alvo o navegador
 * dispara os listeners na ORDEM DE REGISTRO, ignorando a flag de captura
 * (medido no Chromium 145: `bubble(registrado antes)` → `capture(registrado
 * depois)`, tanto em popstate sintético quanto no real). O router registra o
 * `popstate` dele ao criar o `createBrowserHistory`, na avaliação do módulo
 * `router/router.tsx` — antes de `installOfflineDetector` rodar no `main.tsx`.
 * Resultado: "Tentar novamente" na tela "Você está sem internet" abria o aviso
 * de saída em qualquer tela com preenchimento (bug da QA no envio do PDF).
 *
 * Este módulo não tem exports de propósito: ele é importado como PRIMEIRA
 * dependência de `router/router.tsx`, e o `start()` registra o `popstate` do
 * gate antes do router. O resto da fiação (fallback de "Tentar novamente",
 * observador do transporte) continua em `installOfflineDetector`; `start()` é
 * idempotente, então a segunda chamada de lá é no-op.
 */
import { offlineStore } from './offline-store';

offlineStore.start();
